<template>
  <div class="vx-card p-6">
    <div>
      <h1 style="font-size: 40px; text-align: center; font-weight: 600; margin-top: 20px auto;">
        MESAİ SAATLERİ İSTATİSTİKİ BİLGİLER
        <span><feather-icon icon="RefreshCwIcon" title="Yenile" svgClasses="h-6 hover:text-danger cursor-pointer" style="transform: scale(1.6) translate(11%, -10%);" @click="GetTimesheetList('CurrentWeek')"/></span>
      </h1>
    </div>

    <div class="vx-row">
      <div class="personel-search mb-5">
        <label class="text-sm mb-1"><b>Departman</b></label>
        <v-select
          name="assignUserId"
          :disabled="1 == 2"
          v-model="searchTimesheet.departmentId"
          @input="
            searchTimesheet.userId = null;
            getUsers();
            GetTimesheetList('CurrentWeek');
          "
          placeholder="Departman"
          :options="departmentList"
          label="departmentName"
          class="w-full"
          :reduce="(row) => row.departmentId"
        >
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
      </div>
      <div class="personel-search mb-5 ml-5">
        <label class="text-sm mb-1"><b>Personel</b></label>
        <v-select name="assignUserId" :disabled="1 == 2" v-model="searchTimesheet.userId" @input="GetTimesheetList('CurrentWeek')" placeholder="Personel" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
      </div>
    </div>
    <!-- GRAFİK GÖSTERİMİ -->
    <div class="graphics vx-row mb-5 tFlex tFlex_ai-c tFlex_jc_c">
      <div class="graphic">
        <h2 class="card_heading gunluk">
          GÜNLÜK İSTATİSTİK
          <span style="color: rgba(0, 143, 251, 0.85);">{{
            " ( " +
              momentFunction()
                .locale("tr")
                .format("dddd") +
              " ) "
          }}</span>
        </h2>
        <div>
          <apexchart class="card_apex" type="donut" :options="chartOptionsDaily" :series="chartOptionsDaily.series"></apexchart>
        </div>
      </div>
      <div class="graphic" v-if="1==2">
        <h2 class="card_heading aylik">HAFTALIK İSTATİSTİK</h2>
        <div v-if="timesheetStatisticalDataList">
          <apexchart class="card_apex" type="donut" :options="chartOptions" :series="chartOptions.series"></apexchart>
        </div>
      </div>
      <div class="graphic">
        <h2 class="card_heading aylik">AYLIK İSTATİSTİK</h2>
        <div v-if="timesheetMonthlySeriesChart">
          <apexchart class="card_apex" type="donut" :options="chartOptionsMonthly" :series="chartOptionsMonthly.series"></apexchart>
        </div>
      </div>
      <div class="graphic" v-if="1 == 2">
        <h2 class="card_heading aylik">AYLIK MESAİ IP ADRESLERİ</h2>
        <div v-if="timesheetIpMonthlySeriesChart">
          <apexchart class="card_apex" type="donut" :options="chartOptionsIpMonthly" :series="chartOptionsIpMonthly.series"></apexchart>
        </div>
      </div>
    </div>
    <!-- GRAFİK GÖSTERİMİ -->

    <!-------------hafta seçiçi --------------->
    <h3 class="heading heading_center">
      {{
        searchTimesheet.timesheetDate == null
          ? ""
          : momentFunction(searchTimesheet.timesheetDate).year() +
            " Yılının " +
            momentFunction(searchTimesheet.timesheetDate)
              .locale("tr")
              .format("MMMM") +
            " Ayı"
      }}
    </h3>
    <div class="tFlex tFlex_ai-c tFlex_jc-c">
      <div class="back"><feather-icon icon="RewindIcon" title="Önceki Hafta" svgClasses="hover:text-danger cursor-pointer" @click="GetTimesheetList('PreviousMonth')" /></div>
      <div class="hafta">
        <DatePicker type="month" style="width: 150px;" v-model="searchTimesheet.timesheetDate"></DatePicker>
      </div>

      <div class="next"><feather-icon icon="FastForwardIcon" title="Sonraki Hafta" svgClasses="hover:text-danger cursor-pointer" @click="GetTimesheetList('NextMonth')" /></div>
    </div>

    <div class="mb-2">
      <div style="cursor: pointer; width: 100px; margin-bottom: -40px; color: rgba(0, 143, 251, 0.85); font-weight: bold; font-size: 1.2rem;" class="px-4 py-1 flex items-center">
        <JsonExcel :data="hrShiftList" class> <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" /> Excel</JsonExcel>
      </div>
    </div>

    <!-------------hafta seçiçi son --------------->

    <div class="vx-row w-full">
      <div class="vx-col w-full">
        <vs-table search :maxItems="50" :pagination="true" :data="hrShiftList">
          <template slot="thead">
            <!-- <vs-th width="15px">Id</vs-th> -->
            <vs-th width="75px">Mesai Günü</vs-th>
            <vs-th width="150px">Personel Adı</vs-th>
            <vs-th width="150px">Departman</vs-th>
            <vs-th width="150px">Başlama Saati</vs-th>
            <vs-th width="150px">Bitirme Saati</vs-th>
            <vs-th width="100px">Çalışma Zamanı</vs-th>
            <vs-th width="100px">Mola Zamanı</vs-th>
            <vs-th width="100px">Detay & İşlem</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody
              style="cursor: pointer;"
              :key="tr.hrShiftId"
              v-for="(tr, i) in data"
              @click="
                selectedTicketId = tr.supportTicketId;
                supportTicketPopupParent = true;
              "
            >
              <vs-tr>
                <template>
                  <!-- <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.hrShiftId }}</b>
                  </vs-td> -->
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b>
                      {{
                        $moment(tr.shiftDate).format("DD.MM.YYYY") +
                          " " +
                          $moment(tr.shiftDate)
                            .locale("tr")
                            .format("dddd") +
                          " ( " +
                          tr.hrShiftId +
                          " ) "
                      }}</b
                    >
                  </vs-td>
                  <vs-td class="pt-3 pb-3" style="white-space: nowrap;">
                    <b> {{ tr.userName }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.departmentName.substr(0, 20) }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.startTime }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1">
                    <template v-if="tr.startDate != null && tr.finishDate == null">
                      <Blink :duration="750" style="color: #778899;">
                        <b> {{ "Mesai Devam Ediyor " }}</b>
                      </Blink>
                    </template>
                    <template v-else>
                      <b> {{ tr.finishTime }}</b>
                    </template>

                    <!-- <b> {{ tr.startDate != null && tr.finishDate == null ? "Mesai Devam Ediyor - " + $moment.utc($moment($moment().diff(tr.startDate))).format("HH:mm:ss") : tr.finishDate }}</b> -->
                  </vs-td>
                  <!-- <vs-td class="pt-0 pb-1">
                    <b> {{ $moment.utc(tr.workingDuration * 1000).format("HH:mm:ss") }}</b>
                  </vs-td> -->

                  <!-- <vs-td class="pt-0 pb-1">
                    <b> {{ $moment.utc(tr.permissionDuration * 1000).format("HH:mm:ss") }}</b>
                  </vs-td>                  -->

                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.workingTime }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1">
                    <b> {{ tr.permissionTime }}</b>
                  </vs-td>

                  <td>
                    <a
                      href=""
                      @click.prevent="
                        hrShiftSelectedItem = tr;
                        hrShiftSelectedItem.willBeSetFinish = $moment(tr.shiftDate).toDate();
                        popupHrShift = true;
                      "
                      style="color: green; font-size: 10px;"
                      ><b class="mr-5">Log & İşlem </b></a
                    >
                  </td>
                </template>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-prompt
      :vs-title="
        'Mesai İşlemleri # ' +
          hrShiftSelectedItem.userName +
          ' personelinin ' +
          momentFunction(hrShiftSelectedItem.shiftDate).format('DD.MM.YYYY') +
          ' ' +
          momentFunction(hrShiftSelectedItem.shiftDate)
            .locale('tr')
            .format('dddd') +
          ' günkü mesaisinin detay bilgileri '
      "
      vs-button-cancel="border"
      vs-cancel-text="Vazgeç"
      vs-accept-text="Kaydet"
      vs-color="success"
      :vs-active.sync="popupHrShift"
      :vs-buttons-hidden="true"
    >
      <div class="vx-row ml-5 mr-5">
        <div class="vx-row" v-if="hrShiftSelectedItem.finishDate == null && hrShiftSelectedItem.managerUserId == $store.state.userData.userId">
          <div class="vx-col mb-4 md:w-2/3 w-full">
            <label class="text-sm mb-1"><b>Mesai Bitirme Tarihi</b></label>
            <DatePicker type="time" v-model="hrShiftSelectedItem.willBeSetFinish"></DatePicker>
          </div>
          <div class="vx-col md:w-1/3 w-full" style="align-self: center;">
            <vs-button color="danger" size="small" @click="OperateUserShiftManually(tr, 'Stop', 'Mesai bitirme tarihi ' + hrShiftSelectedItem.willBeSetFinish + ' olarak güncellenecektir.')">Güncelle</vs-button>
          </div>
        </div>

        <div class="vx-row">
          <vs-table :maxItems="15" :pagination="true" :data="hrShiftSelectedItem.hrShiftLogList">
            <template slot="thead">
              <!-- <vs-th width="15px">Id</vs-th> -->
              <vs-th width="250px">İşlem Yapan</vs-th>
              <vs-th width="250px">Adına İşlem Yapılan</vs-th>
              <vs-th width="150px">İşlem</vs-th>
              <vs-th width="100px">Log Tarih</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody
                style="cursor: pointer;"
                :key="tr.hrShiftId"
                v-for="(tr, i) in data"
                @click="
                  selectedTicketId = tr.supportTicketId;
                  supportTicketPopupParent = true;
                "
              >
                <vs-tr>
                  <template>
                    <!-- <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.hrShiftId }}</b>
                  </vs-td> -->
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ tr.logUserName }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ tr.userName }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ tr.action }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                      <b> {{ tr.logDate }}</b>
                    </vs-td>
                  </template>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import moment from "moment";
import apexchart from "vue-apexcharts";
import Blink from "vue-blink";
import JsonExcel from "vue-json-excel";

// Cell Renderer

export default {
  components: {
    vSelect,
    apexchart,
    moment,
    Blink,
    JsonExcel,
  },
  data() {
    return {
      hrShiftList: [],
      hrShiftSelectedItem: {},
      popupHrShift: false,
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ///////GÜNLÜK TIMESHEET DEĞİŞKENLER

      timesheetDailySeriesChart: [],
      timesheetDailyLabelsChart: [],

      timesheetStatisticalDailyDataList: null,
      /////////END  DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////

      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ///////AYLIK TIMESHEET DEĞİŞKENLER

      timesheetMonthlySeriesChart: [],
      timesheetMonthlyLabelsChart: [],

      timesheetStatisticalMonthlyDataList: null,
      /////////END  DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////

      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ///////IP AYLIK TIMESHEET DEĞİŞKENLER

      timesheetIpMonthlySeriesChart: [],
      timesheetIpMonthlyLabelsChart: [],

      timesheetStatisticalIpMonthlyDataList: null,
      /////////END  DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////

      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ///////HAFTALIK TIMESHEET DEĞİŞKENLER

      timesheetWeeklySeriesChart: [],
      timesheetWeeklyLabelsChart: [],

      timesheetStatisticalDataList: null,
      /////////END  DEĞİŞKENLER
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////////////////////////////////////////////
      ipResult: null,
      hrTimesheetStatisticalData: {},
      timesheetStartDate: null,
      popupTimesheetTransaction: false,
      selectedPopupDate: null,
      selectedPopupHour: null,
      selectedTimesheetItem: null,
      timesheetItem: null,
      timesheetWorking: {},
      momentFunction: this.$moment,
      searchTimesheet: { hrProjectId: null, projectName: null, departmentId: null, fileList: [], timesheetDate: new Date(), userId: this.$store.state.userData.userId, dateList: [] },
      timesheetList: [],
      selectedWeekDateList: [],

      ///////////////////////////////////////////////////////////////////////
      userList: [],
      selectedProjectAssignItem: {},
      projectAssignItem: {},
      projectAssignList: [{ hrProjectId: null, projectName: null, departmentId: null, fileList: [] }],

      popupDetailAndFile: false,
      popupAssignment: false,
      departmentList: [],
      projectItem: { hrProjectId: null, projectName: null, departmentId: null, fileList: [] },

      selectedProjectItem: {},
      projectList: [{ hrProjectId: undefined, projectName: null, departmentId: null, fileList: [] }],

      statusList: [{ name: "Active" }, { name: "Passive" }],
    };
  },

  computed: {
    chartOptions: function() {
      return {
        colors: ["#B2EBF2", "#80DEEA", "#4DD0E1", "#00BCD4", "#0097A7", "#BDBDBD", "#757575", "#212121"],
        legend: {
          height: 160,
          fontSize: "14px",
          fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          position: "bottom",
          itemMargin: {
            vertical: 10,
          },
          formatter: function(seriesName, opts) {
            return "<p>" + seriesName + "(" + opts.w.globals.series[opts.seriesIndex] + ")" + "</p>";
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.timesheetWeeklyLabelsChart,

        plotOptions: {
          pie: {
            offsetY: 120,
            customScale: 1.5,

            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  show: true,

                  fontFamily: "Rubik",
                  color: "#efefef",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                  color: "#333",
                  offsetY: -10,
                  formatter: function(val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Toplam Süre",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#333",
                  formatter: function(w) {
                    let a = w.globals.seriesTotals
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(2);

                    var d = moment.duration(a * 1000);
                    var s = Math.floor(d.asHours()) + moment.utc(a * 1000).format(":mm:ss");
                    return s;
                  },
                },
              },
            },
          },
        },
        series: this.timesheetWeeklySeriesChart,
      };
    },
    ////////////////////////////
    chartOptionsDaily: function() {
      return {
        colors: ["#B2EBF2", "#80DEEA", "#4DD0E1", "#00BCD4", "#0097A7", "#BDBDBD", "#757575", "#212121"],

        legend: {
          height: 160,
          fontSize: "14px",
          fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          position: "bottom",
          itemMargin: {
            vertical: 10,
          },
          formatter: function(seriesName, opts) {
            return "<p>" + seriesName + "(" + opts.w.globals.series[opts.seriesIndex] + ")" + "</p>";
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.timesheetDailyLabelsChart,

        plotOptions: {
          pie: {
            offsetY: 120,
            customScale: 1.5,

            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  show: true,

                  fontFamily: "Rubik",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                  color: "#333",
                  offsetY: -10,
                  formatter: function(val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Toplam Süre",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#333",
                  formatter: function(w) {
                    let a = w.globals.seriesTotals
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(2);
                    var d = moment.duration(a * 1000);
                    var s = Math.floor(d.asHours()) + moment.utc(a * 1000).format(":mm:ss");
                    return s;
                  },
                },
              },
            },
          },
        },
        series: this.timesheetDailySeriesChart,
      };
    },
    //////////////////////////////////////////

    ////////////////////////////
    chartOptionsMonthly: function() {
      return {
        colors: ["#00BCD4", "#00838F", "#00B8D4", "#0288D1", "#01579B", "#0D47A1", "#1A237E"],

        legend: {
          height: 160,
          fontSize: "14px",
          fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          position: "bottom",
          itemMargin: {
            vertical: 10,
          },
          formatter: function(seriesName, opts) {
            return "<p>" + seriesName + "(" + opts.w.globals.series[opts.seriesIndex] + ")" + "</p>";
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.timesheetMonthlyLabelsChart,

        plotOptions: {
          pie: {
            offsetY: 120,
            customScale: 1.5,

            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  show: true,

                  fontFamily: "Rubik",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                  color: "#333",
                  offsetY: -10,
                  formatter: function(val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Toplam Süre",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#333",
                  formatter: function(w) {
                    let a = w.globals.seriesTotals
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(2);
                    var d = moment.duration(a * 1000);
                    var s = Math.floor(d.asHours()) + moment.utc(a * 1000).format(":mm:ss");
                    return s;
                  },
                },
              },
            },
          },
        },
        series: this.timesheetMonthlySeriesChart,
      };
    },
    //////////////////////////////////////////

    ////////////////////////////
    chartOptionsIpMonthly: function() {
      return {
        colors: ["#00BCD4", "#00838F", "#00B8D4", "#0288D1", "#01579B", "#0D47A1", "#1A237E"],

        legend: {
          height: 160,
          fontSize: "14px",
          fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          position: "bottom",
          itemMargin: {
            vertical: 10,
          },
          formatter: function(seriesName, opts) {
            return "<p>" + seriesName + "(" + opts.w.globals.series[opts.seriesIndex] + ")" + "</p>";
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.timesheetIpMonthlyLabelsChart,

        plotOptions: {
          pie: {
            offsetY: 120,
            customScale: 1.5,

            donut: {
              size: "65%",
              labels: {
                show: true,
                name: {
                  show: true,

                  fontFamily: "Rubik",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "14px",
                  fontWeight: "bold",
                  fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
                  color: "#333",
                  offsetY: -10,
                  formatter: function(val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Toplam Süre",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#333",
                  formatter: function(w) {
                    let a = w.globals.seriesTotals
                      .reduce((a, b) => {
                        return a + b;
                      }, 0)
                      .toFixed(2);
                    var d = moment.duration(a * 1000);
                    var s = Math.floor(d.asHours()) + moment.utc(a * 1000).format(":mm:ss");
                    return s;
                  },
                },
              },
            },
          },
        },
        series: this.timesheetIpMonthlySeriesChart,
      };
    },
    //////////////////////////////////////////
  },
  methods: {
    OperateUserShiftManually: async function(item, operation, messageText) {
      // item.assignStatus = "Completed";
      // item.finishDate = this.$moment().format("l LT");
      // //Insert,Update,Delete
      // item.operation = operation;
      // item.hrProjectId = this.selectedProjectItem.hrProjectId;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        //input:"text",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      this.hrShiftSelectedItem.finish = this.$moment(this.hrShiftSelectedItem.willBeSetFinish).format("l LT");
      this.hrShiftSelectedItem.operation = "StopByManager";
      await repository.postEntity("HumanResource/OperateUserShiftManually", this.hrShiftSelectedItem);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.popupHrShift = false;
      this.GetHRShift();
    },

    GetTimesheetList: async function(operation) {
      //this.$vs.loading();

      if (operation == "PreviousWeek" || operation == "NextWeek" || operation == "CurrentWeek") {
        let weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        if (operation == "PreviousWeek") {
          //weekNumber = this.searchTimesheet.timesheetDate - 1;
          this.searchTimesheet.timesheetDate = this.$moment(this.searchTimesheet.timesheetDate)
            .add(-7, "days")
            .toDate();
          weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        } else if (operation == "NextWeek") {
          this.searchTimesheet.timesheetDate = this.$moment(this.searchTimesheet.timesheetDate)
            .add(7, "days")
            .toDate();
          weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        }

        //hafta başı default pazar olduğu için 1ekleyerek pazartesiye çekiyoruz
        let startDate = this.$moment(this.searchTimesheet.timesheetDate)
          .week(weekNumber)
          .startOf("week");
        let finishDate = this.$moment(this.searchTimesheet.timesheetDate)
          .week(weekNumber)
          .endOf("week");

        // console.log(startDate.format());
        // console.log(finishDate.format());
        // console.log(weekNumber);

        // let diff =moment.duration(finishDate.diff(startDate)) .asDays();
        // let diff = this.$moment(finishDate).diff(startDate);

        //İki tarih arasında kaç gün var bunu bulur
        //console.log(moment.duration(moment(finishDate).diff(startDate)).asDays());
        this.selectedWeekDateList = [];

        while (this.$moment(startDate).startOf("day") <= this.$moment(finishDate).startOf("day")) {
          //console.log(startDate.format("LL"));
          //console.log(startDate.format("LL"));

          this.selectedWeekDateList.push(startDate.toDate());
          this.searchTimesheet.dateList.push(startDate.format("LL"));

          startDate = startDate.add(1, "days");
        }

        //console.log(this.searchTimesheet.dateList);
      } else if (operation == "PreviousMonth" || operation == "NextMonth") {
        let weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        if (operation == "PreviousMonth") {
          //weekNumber = this.searchTimesheet.timesheetDate - 1;
          this.searchTimesheet.timesheetDate = this.$moment(this.searchTimesheet.timesheetDate)
            .add(-1, "months")
            .toDate();
          weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        } else if (operation == "NextMonth") {
          this.searchTimesheet.timesheetDate = this.$moment(this.searchTimesheet.timesheetDate)
            .add(1, "months")
            .toDate();
          weekNumber = this.$moment(this.searchTimesheet.timesheetDate).week();
        }

        //hafta başı default pazar olduğu için 1ekleyerek pazartesiye çekiyoruz
        let startDate = this.$moment(this.searchTimesheet.timesheetDate)
          .week(weekNumber)
          .startOf("week");
        let finishDate = this.$moment(this.searchTimesheet.timesheetDate)
          .week(weekNumber)
          .endOf("week");

        // console.log(startDate.format());
        // console.log(finishDate.format());
        // console.log(weekNumber);

        // let diff =moment.duration(finishDate.diff(startDate)) .asDays();
        // let diff = this.$moment(finishDate).diff(startDate);

        //İki tarih arasında kaç gün var bunu bulur
        //console.log(moment.duration(moment(finishDate).diff(startDate)).asDays());
        this.selectedWeekDateList = [];

        while (this.$moment(startDate).startOf("day") <= this.$moment(finishDate).startOf("day")) {
          //console.log(startDate.format("LL"));
          //console.log(startDate.format("LL"));

          this.selectedWeekDateList.push(startDate.toDate());
          this.searchTimesheet.dateList.push(startDate.format("LL"));

          startDate = startDate.add(1, "days");
        }

      }



      // this.timesheetList = await repository.postEntity("HumanResource/GetHRTimesheet", this.searchTimesheet).then((r) => r.list);

      //this.GetHRTimehseetStatisticalData();
      this.GetHRTimehseetStatisticalDailyData();
      this.GetHRTimehseetStatisticalMonthlyData();
      this.GetHRShift();

      //Kullanılmayacak
      // this.GetHRTimehseetStatisticalIpMonthlyData();

      //console.log(moment("20211201").year());
      //console.log(moment(this.searchTimesheet.momentValue).format("LL"));
      //this.$vs.loading.close();
    },

    ////////////////////////////////////////////////////////////////
    ////////////////GetHRTimehseetStatisticalData/////////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    GetHRTimehseetStatisticalData: async function() {
      this.timesheetStatisticalDataList = await repository.postEntity("HumanResource/GetHRShiftStatisticalData", this.searchTimesheet).then((r) => r.list);
      let xAxisList = [];
      let yAxisList = [];

      this.timesheetStatisticalDataList.forEach((row) => {
        xAxisList.push(row.workingDuration);

        var d = this.$moment.duration(row.workingDuration * 1000);
        var s = Math.floor(d.asHours()) + this.$moment.utc(row.workingDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Çalışma Süresi (" + s);
        //yAxisList.push(row.userName + " - Çalışma Süresi (" + this.$moment.utc(row.workingDuration * 1000).format("HH:mm:ss") + " )");

        xAxisList.push(row.permissionDuration);

        d = this.$moment.duration(row.permissionDuration * 1000);
        s = Math.floor(d.asHours()) + this.$moment.utc(row.permissionDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Mola Süresi (" + s);

        //yAxisList.push(row.userName + " - Mola Süresi (" + this.$moment.utc(row.permissionDuration * 1000).format("HH:mm:ss") + " ) ");
      });

      this.timesheetWeeklyLabelsChart = yAxisList;
      this.timesheetWeeklySeriesChart = xAxisList;
    },

    GetHRTimehseetStatisticalDailyData: async function() {
      this.timesheetStatisticalDailyDataList = await repository
        .postEntity("HumanResource/GetHRShiftStatisticalData", {
          userId: this.searchTimesheet.userId,
          startDate: this.$moment(this.searchTimesheet.momentValue).format("LL"),
          finishDate: this.$moment(this.searchTimesheet.momentValue).format("LL"),
          departmentId: this.searchTimesheet.departmentId,
        })
        .then((r) => r.list);
      let xAxisList = [];
      let yAxisList = [];

      this.timesheetStatisticalDailyDataList.forEach((row) => {
        xAxisList.push(row.workingDuration);

        var d = this.$moment.duration(row.workingDuration * 1000);
        var s = Math.floor(d.asHours()) + this.$moment.utc(row.workingDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Çalışma Süresi (" + s);
        //yAxisList.push(row.userName + " - Çalışma Süresi (" + this.$moment.utc(row.workingDuration * 1000).format("HH:mm:ss") + " )");

        xAxisList.push(row.permissionDuration);

        d = this.$moment.duration(row.permissionDuration * 1000);
        s = Math.floor(d.asHours()) + this.$moment.utc(row.permissionDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Mola Süresi (" + s);

        //yAxisList.push(row.userName + " - Mola Süresi (" + this.$moment.utc(row.permissionDuration * 1000).format("HH:mm:ss") + " ) ");
      });

      this.timesheetDailyLabelsChart = yAxisList;
      this.timesheetDailySeriesChart = xAxisList;
    },
    //Montlhy Data
    GetHRTimehseetStatisticalMonthlyData: async function() {

      const startOfMonth = this.$moment(this.$moment(this.searchTimesheet.timesheetDate))
        .startOf("month")
        .format("l LT");
      const endOfMonth = this.$moment(this.$moment(this.searchTimesheet.timesheetDate))
        .endOf("month")
        .format("l LT");

      this.timesheetStatisticalMonthlyDataList = await repository
        .postEntity("HumanResource/GetHRShiftStatisticalData", { userId: this.searchTimesheet.userId, startDate: startOfMonth, finishDate: endOfMonth, departmentId: this.searchTimesheet.departmentId })
        .then((r) => r.list);
      let xAxisList = [];
      let yAxisList = [];

      this.timesheetStatisticalMonthlyDataList.forEach((row) => {
        xAxisList.push(row.workingDuration);

        var d = this.$moment.duration(row.workingDuration * 1000);
        var s = Math.floor(d.asHours()) + this.$moment.utc(row.workingDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Çalışma Süresi (" + s);
        //yAxisList.push(row.userName + " - Çalışma Süresi (" + this.$moment.utc(row.workingDuration * 1000).format("HH:mm:ss") + " )");

        xAxisList.push(row.permissionDuration);

        d = this.$moment.duration(row.permissionDuration * 1000);
        s = Math.floor(d.asHours()) + this.$moment.utc(row.permissionDuration * 1000).format(":mm:ss");
        yAxisList.push(row.userName + " - Mola Süresi (" + s);

        //yAxisList.push(row.userName + " - Mola Süresi (" + this.$moment.utc(row.permissionDuration * 1000).format("HH:mm:ss") + " ) ");
      });

      this.timesheetMonthlyLabelsChart = yAxisList;
      this.timesheetMonthlySeriesChart = xAxisList;
    },

    //Ip Montlhy Data
    GetHRTimehseetStatisticalIpMonthlyData: async function() {
      const startOfMonth = this.$moment(this.$moment(this.searchTimesheet.momentValue))
        .startOf("month")
        .format("l LT");
      const endOfMonth = this.$moment(this.$moment(this.searchTimesheet.momentValue))
        .endOf("month")
        .format("l LT");

      this.timesheetStatisticalIpMonthlyDataList = await repository
        .postEntity("HumanResource/GetHRShiftStatisticalData", { statisticType: "IpBased", userId: this.searchTimesheet.userId, startDate: startOfMonth, finishDate: endOfMonth })
        .then((r) => r.list);
      let xAxisList = [];
      let yAxisList = [];

      this.timesheetStatisticalIpMonthlyDataList.forEach((row) => {
        xAxisList.push(row.workingDuration);
        yAxisList.push(row.description + " - Çalışma Süresi (" + this.$moment.utc(row.workingDuration * 1000).format("HH:mm:ss") + " )");

        xAxisList.push(row.permissionDuration);
        yAxisList.push(row.description + " - Mola Süresi (" + this.$moment.utc(row.permissionDuration * 1000).format("HH:mm:ss") + " ) ");
      });

      this.timesheetIpMonthlyLabelsChart = yAxisList;
      this.timesheetIpMonthlySeriesChart = xAxisList;
    },

    ////////////////////////////////////////////////////////////////
    ////////////////GetHRTimehseetStatisticalData END/////////////////////////////////////
    ////////////////////////////////////////////////////////////////

    getDepartment: async function() {
      this.departmentList = await repository.getAll("HumanResource/getDepartment").then((r) => r.list);
    },

    GetHRShift: async function() {
      console.log(this.searchTimesheet.timesheetDate);
      const startOfMonth = this.$moment(this.$moment(this.searchTimesheet.timesheetDate))
        .startOf("month")
        .format("l LT");
      const endOfMonth = this.$moment(this.$moment(this.searchTimesheet.timesheetDate))
        .endOf("month")
        .format("l LT");

      this.$vs.loading();
      this.hrShiftList = await repository.postEntity("HumanResource/GetHRShift", { userId: this.searchTimesheet.userId, startDate: startOfMonth, finishDate: endOfMonth, departmentId: this.searchTimesheet.departmentId }).then((r) => r.list);

      this.$vs.loading.close();
    },

    GetHRProjectById: async function(hrProjectId) {
      return await repository.postEntity("HumanResource/GetHRProject", { hrProjectId: hrProjectId }).then((r) => r.list[0]);
    },

    getUsers: async function() {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1, departmentId: this.searchTimesheet.departmentId }).then((r) => r.list);
    },

    GetClientIpAddress: async function() {
      await fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.ipResult = ip;
        });
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.popupHrShift) this.popupHrShift = false;
      }
    });
  },
  created: async function() {
    this.$vs.loading();
    await Promise.all([this.GetClientIpAddress(), this.getDepartment(), this.getUsers(), this.GetTimesheetList("CurrentWeek")]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.personel-search {
  width: 20%;
}
.heading {
  margin-bottom: 0.25rem;
  &_left {
    text-align: left;
  }
  &_center {
    text-align: center;
  }
  &_right {
    text-align: right;
  }
}

.card_heading {
  text-align: center;
  margin-bottom: 1.25rem;
}
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center,
.apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
  display: block;
}

.hafta_secici {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

.tFlex {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.25rem;
  &_flex-1 {
    flex: 1;
  }
  &_ai-c {
    align-items: center;
  }
  &_jc-c {
    justify-content: center;
  }
  &_jc-r {
    justify-content: right;
  }
}
.no-wrap {
  // flex-wrap: nowrap;
}
.graphics {
  .graphic {
    width: calc(25% - 1rem);
  }
}
.personel-search {
  label {
    b {
      display: block;
      margin-bottom: 0.5rem;
    }
  }
}

.flatpickr-calendar.animate.open {
  z-index: 1000900;
}
@media screen and (max-width: 1367px) {
  .personel-search {
    width: 50%;
  }
  .graphics {
    .graphic {
      width: calc(40% - 1rem);
      margin-left: 5%;
    }
  }
}
@media screen and (max-width: 1200px) {
  .personel-search {
    width: 50%;
  }
  .graphics {
    .graphic {
      width: calc(50% - 1rem);
    }
  }
}

@media screen and (max-width: 600px) {
  .personel-search {
    width: 100%;
  }
  .tFlex.graphics {
    display: block;
    .graphic {
      width: 100%;
      height: 100%;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
